import { useState, forwardRef } from "react";
import "./ClassesSection.css";

const classData = {
  Warrior: {
    desc: "Warriors are masters of melee combat, excelling in strength and defense. They lead the charge into battle.",
    stats: "+3 STR & +2 CON",
    weapon: "Swords",
    armor: "Helmets, Armor, Leather, Cloth"
  },
  Mage: {
    desc: "Mages wield powerful spells to control the battlefield, summoning elements and casting destructive magic.",
    stats: "+3 INT & +1 WIS",
    weapon: "Staves",
    armor: "Mage Hat, Cloth Robes"
  },
  Rogue: {
    desc: "Rogues are stealthy and cunning, striking from the shadows and evading danger with agility.",
    stats: "+3 DEX, +1 CON, +1 CHR",
    weapon: "Daggers",
    armor: "Masks, Leather, Cloth"
  },
  Ranger: {
    desc: "Rangers excel in ranged combat, tracking enemies and surviving in the wild with ease.",
    stats: "+1 STR, +2 DEX, +1 CON, +1 WIS",
    weapon: "Bow & Quiver",
    armor: "Crown, Leather, Cloth"
  },
  Priest: {
    desc: "Priests use divine powers to heal allies, support their party, and smite foes with holy magic.",
    stats: "+1 INT, +3 WIS, +1 CHR",
    weapon: "Holy Book",
    armor: "Priest Hat, Cloth Robes"
  }
};

const classList = [
  { name: "Warrior", img: "/classes/warrior.png" },
  { name: "Mage", img: "/classes/mage.png" },
  { name: "Rogue", img: "/classes/rogue.png" },
  { name: "Ranger", img: "/classes/ranger.png" },
  { name: "Priest", img: "/classes/priest.png" }
];

const ClassesSection = forwardRef((props, ref) => {
  const [selectedClass, setSelectedClass] = useState("Warrior");
  const current = classData[selectedClass];

  return (
    <section
      ref={ref}
      className={`section classes ${selectedClass.toLowerCase()}`}
      style={{
        backgroundImage: `url('/classes/ai-${selectedClass.toLowerCase()}.png')`,
      }}
    >
      {/* Selector row */}
      <div className="class-cards">
        {classList.map((cls) => (
          <div
            key={cls.name}
            className={`class-card ${selectedClass === cls.name ? "active" : ""}`}
            onClick={() => setSelectedClass(cls.name)}
          >
            <img src={cls.img} alt={cls.name} />
          </div>
        ))}
      </div>

      {/* Content panel */}
      <div className="class-content">
        <h3>Class: {selectedClass}</h3>
        <p>{current.desc}</p>
        <p><strong>Stats:</strong> {current.stats}</p>
        <p><strong>Weapon:</strong> {current.weapon}</p>
        <p><strong>Armor:</strong> {current.armor}</p>
      </div>
    </section>
  );
});

export default ClassesSection;
